var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MeetingType } from '@web/components/Filters/Elements/MeetingType';
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricTableColMetricPeriodDiffWorkPatternsStyle, widgetMetricTableFigureValueSpanHugClass, widgetMetricTablePairHeaderThAlignBodyTdClass, widgetMetricTablePeriodDiffBeforeTeamTdClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerFitClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell, metricTableTeamAvgDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { useWorkspaceCtx } from '@web/contexts/Workspace';
import { getDemoActivityLabelIdByName } from '@web/lib/demo/data/labels';
import { trpc } from '@web/lib/trpc';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { navigateToSearchMeetingsForDateRange } from '@web/utility/searchMeetingsNavigation';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
function topRecurringEventsTableColgroup(includeTeamDiffColumn) {
    var metricValueCol = { width: '5%', minWidth: '2.75rem' };
    var durationValueCol = { width: '9%', minWidth: '7rem' };
    var periodDiffCol = { width: '6%', minWidth: '5.5rem' };
    var teamDiffCol = { width: '5%', minWidth: '4.75rem' };
    if (includeTeamDiffColumn) {
        return [
            { width: '22%' },
            metricValueCol,
            periodDiffCol,
            teamDiffCol,
            durationValueCol,
            periodDiffCol,
            teamDiffCol,
            metricValueCol,
            periodDiffCol,
            teamDiffCol
        ];
    }
    return [
        { width: '26%' },
        metricValueCol,
        widgetMetricTableColMetricPeriodDiffWorkPatternsStyle,
        durationValueCol,
        widgetMetricTableColMetricPeriodDiffWorkPatternsStyle,
        metricValueCol,
        widgetMetricTableColMetricPeriodDiffWorkPatternsStyle
    ];
}
export var TopRecurringEventsAndMeetings = function (_a) {
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, labelIds = _a.labelIds, _b = _a.isSecondaryDiffHidden, isSecondaryDiffHidden = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = useWorkspaceCtx(), isWorkspaceLoading = _c.isLoading, labels = _c.labels;
    var _d = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _d[0], setDisplayedCount = _d[1];
    var _e = trpc.topRecurringEventsAndMeetings.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        labelIds: labelIds
    }, { enabled: !isWorkspaceLoading }), data = _e.data, isLoading = _e.isLoading, refetch = _e.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var navigationScope = {
        navigateTo: navigateTo,
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: userId,
        orgUnitId: orgUnitId
    };
    var resolveActivityLabelId = function (labelName) {
        var _a, _b;
        return (_b = (_a = labels.find(function (label) { return label.name === labelName; })) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : getDemoActivityLabelIdByName(labelName);
    };
    var navigateToRecurringMeetings = function (labelName) {
        navigateToSearchMeetingsForDateRange(__assign(__assign({}, navigationScope), { meetingType: MeetingType.RECURRING, activityLabelId: resolveActivityLabelId(labelName) }));
    };
    var clickableValueCell = function (id, value, onClick, className) {
        if (className === void 0) { className = widgetMetricTableValueTdClass; }
        return ({
            id: id,
            className: classNames(className, 'cursor-pointer'),
            render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerFitClass, 'cursor-pointer'), onClick: onClick }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanHugClass }, { children: value })) }))); }
        });
    };
    var showTeamDiff = !!userId;
    var headerMetricClass = widgetMetricTablePairHeaderThAlignBodyTdClass;
    var metricHeaderColspanMain = showTeamDiff ? 3 : 2;
    var participantsHeaderColspan = showTeamDiff ? 3 : 2;
    var columns = [
        {
            title: (_jsx("div", __assign({ className: "flex items-center gap-2" }, { children: _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.label') }) }))),
            isVisible: true,
            className: 'max-w-0 min-w-0 !text-left !pl-3 !pr-4 whitespace-normal'
        },
        {
            title: (_jsx("div", __assign({ className: "flex items-center justify-start gap-2" }, { children: _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.totalAmount') }) }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspanMain
        },
        {
            title: (_jsx("div", __assign({ className: "flex items-center justify-start gap-2" }, { children: _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.totalDuration') }) }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: metricHeaderColspanMain
        },
        {
            title: (_jsx("div", __assign({ className: "flex items-center justify-start gap-2" }, { children: _jsx("span", { children: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.numberOfParticipants') }) }))),
            isVisible: true,
            className: headerMetricClass,
            colspan: participantsHeaderColspan
        }
    ];
    var items = data || [];
    var displayedItems = items.slice(0, displayedCount);
    var hasMore = items.length > displayedCount;
    var tableData = displayedItems.map(function (item) {
        var rowKey = item.labelName;
        var amountCells = [
            clickableValueCell("totalAmount-value-".concat(rowKey), item.totalAmount.current, function () { return navigateToRecurringMeetings(item.labelName); }),
            metricTablePeriodDiffRowCell("totalAmount-period-".concat(rowKey), item.totalAmount.previous, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            amountCells.push(metricTableTeamAvgDiffRowCell("totalAmount-team-".concat(rowKey), item.totalAmount.teamAverage, isSecondaryDiffHidden));
        }
        var durationCells = [
            clickableValueCell("totalDuration-value-".concat(rowKey), item.totalDuration.current, function () { return navigateToRecurringMeetings(item.labelName); }, "".concat(widgetMetricTableValueTdClass, " overflow-hidden")),
            metricTablePeriodDiffRowCell("totalDuration-period-".concat(rowKey), item.totalDuration.previous, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            durationCells.push(metricTableTeamAvgDiffRowCell("totalDuration-team-".concat(rowKey), item.totalDuration.teamAverage, isSecondaryDiffHidden));
        }
        var participantsCells = [
            clickableValueCell("participants-value-".concat(rowKey), item.numberOfParticipants.current, function () { return navigateToRecurringMeetings(item.labelName); }),
            metricTablePeriodDiffRowCell("participants-period-".concat(rowKey), item.numberOfParticipants.previous, TablesDiffColorsConfig.GREEN, showTeamDiff ? widgetMetricTablePeriodDiffBeforeTeamTdClass : undefined, showTeamDiff ? { innerJustify: 'end' } : undefined)
        ];
        if (showTeamDiff) {
            participantsCells.push(metricTableTeamAvgDiffRowCell("participants-team-placeholder-".concat(rowKey), undefined, true));
        }
        return __spreadArray(__spreadArray(__spreadArray([
            {
                id: "label-".concat(rowKey),
                className: classNames(widgetMetricTablePrimaryLabelTdClass, 'max-w-0 whitespace-normal !pr-4 cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: "min-w-0 w-full cursor-pointer font-semibold break-words [overflow-wrap:anywhere]", onClick: function () { return navigateToRecurringMeetings(item.labelName); } }, { children: item.labelName }))); }
            }
        ], amountCells, true), durationCells, true), participantsCells, true);
    });
    return (_jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.topRecurringEventsAndMeetings'), description: t('widgetTitleDescriptions.scheduleAndAttendance.topRecurringEventsAndMeetings'), insightType: InsightTypeEnum.topRecurringEventsAndMeetings, insightsData: displayedItems, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.topRecurringEventsAndMeetings'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, displayedItems.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.label')] = item.labelName,
                                        _a[t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.totalAmount')] = item.totalAmount.current,
                                        _a[t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.totalDuration')] = item.totalDuration.current,
                                        _a[t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.numberOfParticipants')] = item.numberOfParticipants.current,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(displayedItems) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(displayedItems) ? [] : tableData, columnColStyles: topRecurringEventsTableColgroup(showTeamDiff), tableClassName: classNames('w-full table-auto', showTeamDiff ? 'min-w-[72rem]' : 'min-w-[52rem]'), rowClassName: "[&>td]:align-top" }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
};
